<div *ngIf="settings" class="p-g" rte="PE">
    <form #form="ngForm" class="inputs-group p-g-12" (ngSubmit)="save()" rte="PF">
        <div class="inputs-group-row" rte="RT">
            <label for="username" class="inputs-group-row-name" rte="RU">User name:</label>
            <div class="inputs-group-row-value" rte="RV">
                <input [(ngModel)]="username"
                       pInputText
                       id="username"
                       name="username"
                       rte="RW"
                       required
                       (ngModelChange)="changedInputUsername($event)"/>
            </div>
        </div>
        <div class="inputs-group-row" rte="RT">
            <label for="password" class="inputs-group-row-name" rte="RU">Password:</label>
            <div class="inputs-group-row-value" rte="RV">
                <input #passwordInput="ngModel" [(ngModel)]="password"
                       pPassword
                       showPassword
                       id="password"
                       name="password"
                       rte="RW"
                       required
                       (ngModelChange)="changedInputPassword($event)"/>
            </div>
        </div>

        <div class="inputs-group-row" rte="RT">
            <div class="inputs-group-row-name">
                <p-button label="Test Connection" (onClick)="testApi()" [disabled]="disableTest"></p-button>
            </div>
            <div class="inputs-group-row-value">
                <span class="status-header" *ngIf="testApiStatus === testApiStatusEnum.Passed">Connection Passed</span>
                <span class="status-header" *ngIf="testApiStatus === testApiStatusEnum.Failed">Connection Failed</span>
                <div class="inputs-group-row-value" *ngIf="showRavenUpdateMessage">
                    <span class="status-header">Refreshing Raven Data</span>
                    <div class="splash-loader-container" style="position:inherit">
                        <svg class="splash-loader" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="splash-path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons-panel">
            <button pButton type="submit" label="Save" [disabled]="!form.valid || disableSave"></button>
        </div>
    </form>
</div>